import { ReactElement } from 'react';
import { getAsset, getStyle } from '@utils/style';
import { DynamicTypography } from '@components/DynamicTypography';

interface PII {
  firstName: string;
  lastName: string;
}

interface HeaderProps {
  className?: string;
  title: string;
  pii?: PII;
  subTitle?: string;
  questionnaireType?: string;
}

export const Header = ({
  className,
  title,
  pii,
  subTitle,
  questionnaireType
}: HeaderProps): ReactElement => {
  return (
    <div className={`questionnaire-header ${className?.trim() || ''}`}>
      <div className="logo">
        <img src={getAsset('image', getStyle('LOGO', true))} alt="Logo" />
      </div>
      <div className="title">
        <h1 style={{ color: getStyle('TITLE_COLOR', true) }}>
          {title}
          {pii && ` ${pii.firstName} ${pii.lastName}`}
        </h1>
        {subTitle && <DynamicTypography content={subTitle} />}
      </div>
      {questionnaireType && <div className="questionnaire-type">{questionnaireType}</div>}
    </div>
  );
};
